import _ from 'lodash'
import Backbone from 'backbone'
import template from './boolean-filter.hbs'
import dropdown from 'scoreboard/components/dropdown'

const BooleanFilter = Backbone.View.extend({

	className: 'report-filters boolean-filter filter',

	initialize: function(options) {
		this.options = options
		this.data = _.defaults({}, this.options.data)
	},

	render: function() {
		this.$el.html(template())
		let initValue = _.get(this.data,'value','true')
		dropdown.idLabels(this.$('select'), this.options.choices, initValue+'')
		return this
	},

	//returns the data captured by this filter
	gather: function() {
		this.data.value = this.$('select').val()
		this.data.label = this.$('select option:selected').text()
		return this.data
	}

})

export default BooleanFilter

BooleanFilter.__filename__ = 'reports/common/filter/boolean-filter.js'
